import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { shallowRef, onMounted } from 'vue'
import { Loading } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 显示一个加载动画
    loading: {
        type: Boolean,
        default: false
    },
    flex: {
        type: Boolean,
        default: false
    },
},
  emits: ['ready'],
  setup(__props, { emit }) {




const viewRef = shallowRef()

onMounted(() => {
    emit('ready', viewRef.value)
})

return (_ctx: any,_cache: any) => {
  const _component_app_scroll_view = _resolveComponent("app-scroll-view")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "viewRef",
    ref: viewRef,
    class: "app-view"
  }, [
    _renderSlot(_ctx.$slots, "header"),
    _createVNode(_component_app_scroll_view, {
      class: _normalizeClass(['app-view__body', __props.flex && 'flex'])
    }, {
      default: _withCtx(() => [
        (__props.loading)
          ? (_openBlock(), _createBlock(_unref(Loading), {
              key: 0,
              class: "app-view__loading"
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]),
    _renderSlot(_ctx.$slots, "footer")
  ], 512))
}
}

})